var e = /* @__PURE__ */ ((o) => (o.SansSerif = "Scto Grotesk A", o.Serif = "Recife Text", o))(e || {});
const L = {
  Regular: 400
}, k = {
  Thin: 100,
  Light: 300,
  Regular: 400,
  Medium: 500,
  Bold: 700,
  Black: 900
}, l = Object.freeze({
  fontFamily: e.SansSerif,
  fontWeight: 500,
  fontSize: "96px",
  letterSpacing: "-0.06em",
  lineHeight: "100%"
}), t = {
  fontFamily: e.SansSerif,
  fontWeight: 500
}, p = Object.freeze({
  ...t,
  fontSize: "74px",
  letterSpacing: "-0.056em",
  lineHeight: "106%"
}), z = Object.freeze({
  ...t,
  fontSize: "60px",
  letterSpacing: "-0.052em",
  lineHeight: "110%"
}), b = Object.freeze({
  ...t,
  fontSize: "48px",
  letterSpacing: "-0.052em",
  lineHeight: "106%"
}), s = Object.freeze({
  ...t,
  fontSize: "40px",
  letterSpacing: "-0.05em",
  lineHeight: "110%"
}), d = Object.freeze({
  ...t,
  fontSize: "32px",
  letterSpacing: "-0.05em",
  lineHeight: "110%"
}), j = Object.freeze({
  ...t,
  fontSize: "24px",
  letterSpacing: "-0.02em",
  lineHeight: "120%"
}), a = {
  fontFamily: e.Serif,
  fontWeight: 400,
  letterSpacing: "-0.02em"
}, O = Object.freeze({
  ...a,
  fontSize: "40px",
  lineHeight: "120%"
}), H = Object.freeze({
  ...a,
  fontSize: "32px",
  lineHeight: "150%"
}), m = Object.freeze({
  ...a,
  fontSize: "24px",
  lineHeight: "130%"
}), x = Object.freeze({
  ...a,
  fontSize: "18px",
  lineHeight: "130%"
}), u = Object.freeze({
  ...a,
  fontSize: "16px",
  lineHeight: "130%"
}), n = Object.freeze({
  fontFamily: e.SansSerif,
  fontSize: "16px",
  fontWeight: 400,
  letterSpacing: "-0.01em",
  lineHeight: "154%"
}), P = Object.freeze({
  ...n,
  fontWeight: "500"
}), g = Object.freeze({
  ...n,
  fontSize: "20px",
  letterSpacing: "-0.03em",
  lineHeight: "130%"
}), B = Object.freeze({
  ...g,
  fontWeight: "500"
}), f = Object.freeze({
  ...n,
  fontSize: "18px",
  letterSpacing: "-0.03em"
}), W = Object.freeze({
  ...f,
  fontWeight: "500"
}), S = Object.freeze({
  ...n,
  fontSize: "14px",
  letterSpacing: "-0.02em",
  lineHeight: "130%"
}), $ = Object.freeze({
  ...S,
  fontWeight: "500"
}), h = Object.freeze({
  ...n,
  fontSize: "12px",
  letterSpacing: "-0.02em",
  lineHeight: "130%"
}), y = Object.freeze({
  ...h,
  fontWeight: "500"
}), _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Display: l,
  Heading1: p,
  Heading2: z,
  Heading3: b,
  Heading4: s,
  Heading5: d,
  Heading6: j,
  Paragraph: n,
  ParagraphBold: P,
  ParagraphLarge: f,
  ParagraphLargeBold: W,
  ParagraphSmall: S,
  ParagraphSmallBold: $,
  ParagraphXL: g,
  ParagraphXLBold: B,
  ParagraphXS: h,
  ParagraphXSBold: y,
  Subhead1: O,
  Subhead2: H,
  Subhead3: m,
  Subhead4: x,
  Subhead5: u
}, Symbol.toStringTag, { value: "Module" })), r = {
  fontFamily: e.SansSerif,
  fontWeight: 500,
  letterSpacing: "-0.05em",
  lineHeight: "120%"
}, M = Object.freeze({
  ...r,
  fontSize: "32px"
}), R = Object.freeze({
  ...r,
  fontSize: "24px"
}), T = Object.freeze({
  ...r,
  fontSize: "20px"
}), v = Object.freeze({
  ...r,
  fontSize: "18px",
  letterSpacing: "-0.02em"
}), i = {
  fontFamily: e.Serif,
  fontWeight: 400,
  letterSpacing: "-0.02em",
  lineHeight: "154%"
}, A = Object.freeze({
  ...i,
  fontSize: "32px",
  lineHeight: "150%"
}), D = Object.freeze({
  ...i,
  fontSize: "24px",
  lineHeight: "150%"
}), G = Object.freeze({
  ...i,
  fontSize: "18px"
}), q = Object.freeze({
  ...i,
  fontSize: "16px"
}), w = Object.freeze({
  ...i,
  fontSize: "14px"
}), C = Object.freeze({
  ...i,
  fontSize: "12px"
}), c = Object.freeze({
  fontFamily: e.SansSerif,
  fontSize: "16px",
  fontWeight: 400,
  letterSpacing: "-0.02em",
  lineHeight: "154%"
}), E = Object.freeze({
  ...c,
  fontWeight: 500
}), X = Object.freeze({
  ...c,
  fontSize: "14px",
  lineHeight: "130%"
}), I = Object.freeze({
  ...X,
  fontWeight: 500
}), F = Object.freeze({
  ...c,
  fontSize: "12px",
  lineHeight: "130%"
}), J = Object.freeze({
  ...F,
  fontWeight: 500
});
export {
  e as FontFamily,
  M as Heading1,
  R as Heading2,
  T as Heading3,
  v as Heading4,
  _ as Marketing,
  c as Paragraph,
  E as ParagraphBold,
  X as ParagraphSmall,
  I as ParagraphSmallBold,
  F as ParagraphXS,
  J as ParagraphXSBold,
  k as SansSerifWeight,
  L as SerifWeight,
  A as Subhead1,
  D as Subhead2,
  G as Subhead3,
  q as Subhead4,
  w as Subhead5,
  C as Subhead6
};
